import { Divider, Tag } from "antd";

import type { AccountDetailVO } from "@/api/accounts/type";
import { useDict } from "@/hooks/useDict";
import { cn } from "@/lib/cn";
import { ENABLE_STATUS_CONFIG } from "@/types";
import { emptyPlaceholder } from "@/utils";

import { RISK_COLOR_MAP } from "../constants";

/** 账号详情顶部信息名片 */
export const AccountHeaderCard = ({ accountDetail }: { accountDetail: AccountDetailVO | null }) => {
  const { getDictLabel } = useDict();
  /** 账号状态 */
  const st = accountDetail ? ENABLE_STATUS_CONFIG[accountDetail.status] : undefined;
  /** 显示名称：昵称 */
  const displayName = accountDetail?.profile?.nickname;
  /** 头像文本 */
  const avatarText = displayName?.charAt(0);

  return (
    <div className="mt-2 flex items-center gap-4 p-3 bg-slate-50 rounded-xl border">
      <div className="w-14 h-14 rounded-xl bg-linear-to-br from-orange-400 via-orange-500 to-amber-500 flex items-center justify-center text-white font-bold text-xl shadow-sm shrink-0">
        {avatarText}
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1 flex-wrap">
          <h3 className="font-bold text-lg truncate m-0">{emptyPlaceholder(displayName)}</h3>
          {st && (
            <Tag bordered color={st.color} className="text-[10px] m-0 border-0">
              {st.label}
            </Tag>
          )}

          {accountDetail?.realName?.verifyStatus && (
            <Tag
              bordered
              className={cn(
                "text-[10px] m-0 border-0",
                RISK_COLOR_MAP[accountDetail?.realName?.verifyStatus],
              )}
            >
              {getDictLabel("userRealNameStatus", accountDetail?.realName?.verifyStatus)}
            </Tag>
          )}
        </div>
        <div className="flex items-center gap-3 text-xs text-slate-500">
          <span>{emptyPlaceholder(accountDetail?.phone)}</span>
          <Divider type="vertical" className="h-3 m-0" />
          <span className="font-mono">{emptyPlaceholder(accountDetail?.userCode)}</span>
          {accountDetail?.profile?.email && (
            <>
              <Divider type="vertical" className="h-3 m-0" />
              <span>{emptyPlaceholder(accountDetail.profile.email)}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
